@if (data) {
<section
  class="user-info"
  role="group"
  aria-label="Bruger- og værksoplysninger"
>
  <div class="user-info__top">
    <p class="user-info__value bold">
      {{ data.user.name }} ({{ data.user.initialer }})
    </p>
    <service-pro-cookie-consent-button [showLabel]="false" />
  </div>
</section>
}
